import { readJson } from '@ms-cloudpack/json-utilities';
import { findProjectRoot } from '@ms-cloudpack/path-utilities';
import path from 'path';

/**
 * Gets the name of the workspace or git repository from the root package.json.
 * @returns The name of the workspace or repository. If the name is not found, undefined is returned.
 */
export async function getRepositoryName(appPath: string): Promise<string | undefined> {
  try {
    const rootPath = findProjectRoot(appPath) || appPath;
    const rootPackageJsonPath = path.join(rootPath, 'package.json');
    const packageJsonContent = (await readJson(rootPackageJsonPath)) as { name?: string };
    if (!packageJsonContent) {
      console.warn(`Could not read ${rootPackageJsonPath}.`);
      return undefined;
    }

    return packageJsonContent.name;
  } catch (e) {
    console.warn(
      'An error occurred while getting repository name. This is not a critical error. You can continue to work.',
      e,
    );
    return undefined;
  }
}
